import { useState, useEffect } from 'react';
import { getTeamList } from '@ifa/utils';
import type { Team } from '../types';

/**
 * useTeams - 加载团队列表
 */
export function useTeams(propTeams?: Team[], enabled: boolean = true) {
  const [teams, setTeams] = useState<Team[]>(propTeams || []);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    // 如果传入了 teams，不需要加载
    if (propTeams && propTeams.length > 0) {
      setTeams(propTeams);
      return;
    }

    const loadTeams = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getTeamList();
        // 转换为组件需要的格式
        const formattedTeams: Team[] = (data || []).map((item) => ({
          id: item.id!,
          teamName: item.teamName!,
          number: item.number || 0,
          managerId: item.managerId,
          managerName: item.managerName,
        }));
        setTeams(formattedTeams);
      } catch (err) {
        console.error('載入團隊列表失敗:', err);
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    };

    loadTeams();
  }, [propTeams, enabled]);

  return { teams, loading, error };
}
